import { Grid } from '@mui/material';
import DashboardKurulMeetingsCard from '../DashboardKurulMeetingsCard';
import DashboardUserInfoMeetingsCard from '../DashboardUserInfoMeetingsCard';
import DashboardYKMeetingsCard from '../DashboardYKMeetingsCard';
import { isRoleCheckList } from 'app/utils/appHelpers';
import DashboardUyeCard from '../DashboardUyeCard';
import DashboardAnnouncementsCard from '../DashboardAnnouncementsCard';

function DashboardSuperUserDesign({ userRoles, countUserInfo, countList, ykCountList }) {
    return (
        <>
            <Grid container spacing={1} direction="row" style={{ marginBottom: 3 }}>
                <Grid item xs={12} md={12} lg={9}>
                    {isRoleCheckList(userRoles, [100]) ?
                        <DashboardUyeCard countUserInfo={countUserInfo} type={"uye"}></DashboardUyeCard>
                        :
                        <DashboardUyeCard countUserInfo={countUserInfo} type={"superuser"}></DashboardUyeCard>
                    }
                </Grid>

                <Grid item xs={12} md={3} lg={3}>
                    {/* <DashboardAnnouncementsCard /> */}
                    <DashboardUserInfoMeetingsCard countList={countUserInfo} />
                </Grid>






            </Grid>

            {isRoleCheckList(userRoles, [100]) ?
                null :
                <Grid container spacing={1} direction="row" style={{ marginBottom: 3 }}>
                    <Grid item xs={12} md={9} lg={9}>
                        <DashboardKurulMeetingsCard countList={countList} />
                    </Grid>

                    <Grid item xs={12} md={12} lg={9}>
                        <DashboardYKMeetingsCard countList={ykCountList} />
                    </Grid>
                </Grid>
            }
        </>
    );
}

export default DashboardSuperUserDesign; 